const LandingPages = () => {

    // Show hidden products on click

    const hiddenProducts = document.getElementsByClassName('hidden-product-item-js');
    const hiddenProductsTarget = document.getElementsByClassName('hidden-product-target-js');
    const hideProducts = document.getElementsByClassName('back-product-js');
    const bodyTag = document.getElementsByTagName('body')[0];

    if(hiddenProducts) {
        for(var i = 0; i < hiddenProducts.length; i++) {
            hiddenProducts[i].addEventListener('click', function() {

                let clickedElement = this;

                if(hiddenProductsTarget) {
                    for(var i = 0; i < hiddenProductsTarget.length; i++) {
                        hiddenProductsTarget[i].classList.remove('active');
                        bodyTag.classList.remove('overflow-hidden');
                        if(clickedElement.dataset.hiddenProductTarget == hiddenProductsTarget[i].dataset.hiddenProductName) {
                            hiddenProductsTarget[i].classList.add('active');
                            bodyTag.classList.add('overflow-hidden');
                        }
                    }
                }

            })
        }
    }

    // Hide hidden products on click

    if(hideProducts) {
        for(var i = 0; i < hideProducts.length; i++) {
            hideProducts[i].addEventListener('click', function() {

                for(var i = 0; i < hiddenProductsTarget.length; i++) {
                    hiddenProductsTarget[i].classList.remove('active');
                }
                bodyTag.classList.remove('overflow-hidden');

            })
        }
    }

    // Show more info on footer click

    const footerShowMoreBtns = document.getElementsByClassName('lp-animal__footer-wrapper-title');

    if(footerShowMoreBtns) {
        for(var i = 0; i < footerShowMoreBtns.length; i++) {
            footerShowMoreBtns[i].addEventListener('click',function() {

                if(this.nextElementSibling.classList.contains('active')) {
                    this.nextElementSibling.classList.remove('active');
                } else {

                    for(var j = 0; j < footerShowMoreBtns.length; j++) {
                        footerShowMoreBtns[j].nextElementSibling.classList.remove('active');
                    }

                    this.nextElementSibling.classList.add('active'); 

                }

            })
        }
    }

    // Show more info in description:

    const showMoreInfoBtn = document.querySelectorAll('.lp-product-item__text-info-title .show-more');

    if(showMoreInfoBtn) {
        for(var i = 0; i < showMoreInfoBtn.length; i++) {

            showMoreInfoBtn[i].addEventListener('click', function() {

                if(this.parentNode.classList.contains('active')) {
                    this.parentNode.classList.remove('active');
                    this.innerText = 'więcej informacji >>';
                } else {
                    this.parentNode.classList.add('active');
                    this.innerText = 'mniej informacji >>';
                }

            })

        }
    }

    // Select correct colors in products:

    const colorSelector = document.getElementsByClassName('new-global-lp__product-info-colors-items-item');

    if(colorSelector) {
        for(var i = 0; i < colorSelector.length; i++) {
            colorSelector[i].addEventListener('click', function() {
                // Get clicked element parent to remove class only for childs inside this wrapper
                let clickedParent = this.parentNode.getElementsByClassName('new-global-lp__product-info-colors-items-item');
                for(var j = 0; j < clickedParent.length; j++) {
                    clickedParent[j].classList.remove('active');
                }
                this.classList.add('active');
                this.parentNode.parentNode.nextElementSibling.href = this.dataset.colorLink;
                let colorNameThis = this.dataset.colorName;
                let imageSelector = this.parentNode.parentNode.parentNode.parentNode.querySelectorAll('.new-global-lp__product-image img');

                if(imageSelector) {

                    for(var i = 0; i < imageSelector.length; i++) {
                        imageSelector[i].classList.remove('active');
                    }

                    for(var i = 0; i < imageSelector.length; i++) {
                        if(imageSelector[i].dataset.colorName === colorNameThis) {
                            imageSelector[i].classList.add('active');
                        }
                    }

                }
            })
        }
    }
    
    // Change packages and quantity in product purchase

    // Change quantity input value on click

    const quantityWrapper = document.getElementsByClassName('lp-senior-quantity-js');

    if(quantityWrapper) {
        for(var i = 0; i < quantityWrapper.length; i++) {

            const quantityMinus = quantityWrapper[i].getElementsByClassName('lp-senior__products-item-text-buy-quantity-minus')[0];
            const quantityPlus = quantityWrapper[i].getElementsByClassName('lp-senior__products-item-text-buy-quantity-plus')[0];
            const quantityInput = quantityWrapper[i].querySelector('input');
            const quantityLink = quantityWrapper[i].getElementsByClassName('lp-senior-buy-js')[0];

            if(quantityInput) {
                quantityInput.addEventListener('change', function() {
                    if(Number(this.value) < 1) {
                        this.value = 1;
                    }
                    changeSeniorLink(this.parentNode.parentNode.parentNode.parentNode);
                })
            }

            if(quantityMinus) {
                quantityMinus.addEventListener('click', function() {
                    if(Number(this.nextElementSibling.value) > 1) {
                        this.nextElementSibling.value = Number(this.nextElementSibling.value) - 1;
                        changeSeniorLink(this.parentNode.parentNode.parentNode.parentNode);
                    }
                })
            }

            if(quantityPlus) {
                quantityPlus.addEventListener('click', function() {
                    this.previousElementSibling.value = Number(this.previousElementSibling.value) + 1;
                    changeSeniorLink(this.parentNode.parentNode.parentNode.parentNode);
                })
            }

        }
    }

    // Change active packaged on click

    const seniorPackages = document.getElementsByClassName('lp-senior__products-item-text-packages');

    if(seniorPackages) {
        for(let i = 0; i < seniorPackages.length; i++) {
            const allSeniorPackagesClick = seniorPackages[i].getElementsByClassName('lp-senior-package-js');
            
            for(var j = 0; j < allSeniorPackagesClick.length; j++) {
                allSeniorPackagesClick[j].addEventListener('click', function() {
                    for(var k = 0; k < allSeniorPackagesClick.length; k++) {

                        allSeniorPackagesClick[k].classList.remove('active');
        
                    }
                    let thisParent = this.closest('.lp-product-item');
                    this.classList.add('active');

                    changeSeniorLink(this.parentNode.parentNode.parentNode);
                })
            }
            
        }
    }

    // Change link


    function changeSeniorLink(parent) {

        const activePackage = parent.querySelector('.lp-senior__products-item-text-packages-item.active').dataset.packageType;
        const activeQuanti  = parent.querySelector('.lp-senior-quantity-js input').value;
        const productBtn    = parent.querySelector('.lp-senior-buy-js');
        let basicLink     = '';

        if(parent) {
            if(parent.dataset.productType === 'BS.03') {
                if(activePackage == 'miesiecznie') {
                    basicLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=10072&quantity=' + activeQuanti;
                } else if(activePackage == 'polrocznie') {
                    basicLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=10073&quantity=' + activeQuanti;
                } else if(activePackage == 'rocznie') {
                    basicLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=10076&quantity=' + activeQuanti;
                }
            } else if(parent.dataset.productType === 'BS.04') {
                if(activePackage == 'miesiecznie') {
                    basicLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=10069&quantity=' + activeQuanti;
                } else if(activePackage == 'polrocznie') {
                    basicLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=10070&quantity=' + activeQuanti;
                } else if(activePackage == 'rocznie') {
                    basicLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=10071&quantity=' + activeQuanti;
                }
            }
            
            if(productBtn) {
                productBtn.href = basicLink;
            }
    
        }

    }

    // LP Senior - END

    // Generate link for packages click event on lp kid
    
    const generateLinkPackages = document.getElementsByClassName('generate-link-package-js');

    if(generateLinkPackages) {
        for(let i = 0; i < generateLinkPackages.length; i++) {
            generateLinkPackages[i].addEventListener('click', function() {
                changePackage(this)
            })
        }
    }


    // Global change watches on click
    const bottomInfoItems = document.getElementsByClassName('info-item-text-js');
    const bottomInfoImages  = document.getElementsByClassName('info-item-image-js');

    if(bottomInfoItems) {
        for(var i = 0; i < bottomInfoItems.length; i++) {
            bottomInfoItems[i].addEventListener('click', function() {

                let activeIndex = this.dataset.itemNumber;

                for(var i = 0; i < bottomInfoItems.length; i++) {
                    bottomInfoItems[i].classList.remove('active');
                }

                this.classList.add('active');

                for(var j = 0; j < bottomInfoImages.length; j++) {
                    bottomInfoImages[j].classList.remove('active');

                    if(bottomInfoImages[j].dataset.imageNumber === activeIndex) {
                        bottomInfoImages[j].classList.add('active');
                    }
                }
            })
        }
    }

    // Toggle burger on lp

    const toggleLpBurger = document.getElementsByClassName('toggle-burger-js')[0];

    if(toggleLpBurger) {
        toggleLpBurger.addEventListener('click', function() {

            if(this.parentNode.classList.contains('active')) {
                this.parentNode.classList.remove('active');
            } else {
                this.parentNode.classList.add('active');
            }

        })
    }
    
    // Click event on colors
    const allChangeColorItems = document.getElementsByClassName('generate-link-color-js');

    if(allChangeColorItems) {
        for(var i = 0; i < allChangeColorItems.length; i++) {
            allChangeColorItems[i].addEventListener('click',function () {
                let changeColorItem = this;

                changeColor(changeColorItem)
            });
        }
    }

    const quantityWrappers = document.getElementsByClassName('link-quantity-js');

    if(quantityWrappers) {
        for(var i = 0; i < quantityWrappers.length; i++) {

            const quantityMinus = quantityWrappers[i].getElementsByClassName('link-quantity-minus-js')[0];
            const quantityPlus = quantityWrappers[i].getElementsByClassName('link-quantity-plus-js')[0];
            const quantityInput = quantityWrappers[i].querySelector('input');

            if(quantityInput) {
                quantityInput.addEventListener('change', function() {
                    let thisParent = this.closest('.lp-product-item');
                    if(Number(this.value) < 1) {
                        this.value = 1;
                    }
                    generateProductLink(thisParent);
                })
            }
    
            if(quantityMinus) {
                quantityMinus.addEventListener('click', function() {
                    let thisParent = this.closest('.lp-product-item');
                    if(Number(this.nextElementSibling.value) > 1) {
                        quantityInput.value = Number(quantityInput.value) - 1;
                        generateProductLink(thisParent);
                    }
                })
            }
    
            if(quantityPlus) {
                quantityPlus.addEventListener('click', function() {
                    let thisParent = this.closest('.lp-product-item');
                    quantityInput.value = Number(quantityInput.value) + 1;
                    generateProductLink(thisParent);
                })
            }
                
        }
    }

    // Global change product package:

    function changePackage(clickedItem) {

        let thisParent = clickedItem.closest('.lp-product-item');
        let allPackagesHere = clickedItem.parentNode.getElementsByClassName('generate-link-package-js');

        for(var k = 0; k < allPackagesHere.length; k++) {
            allPackagesHere[k].classList.remove('active');
        }

        clickedItem.classList.add('active');

        generateProductLink(thisParent);

    }


    // Global change product color

    function changeColor (clickedItem) {

        let clickedParent = clickedItem.parentNode.getElementsByClassName('generate-link-color-js');
        for(var j = 0; j < clickedParent.length; j++) {
            clickedParent[j].classList.remove('active');
        }
        clickedItem.classList.add('active');
        let colorNameThis = clickedItem.dataset.colorName;
        let thisParent = clickedItem.closest('.lp-product-item');
        let imageSelector = thisParent.querySelectorAll('.generate-link-images-js img');

        if(imageSelector) {

            for(var i = 0; i < imageSelector.length; i++) {
                imageSelector[i].classList.remove('active');
            }

            for(var i = 0; i < imageSelector.length; i++) {
                if(imageSelector[i].dataset.productImageColor === colorNameThis) {
                    imageSelector[i].classList.add('active');
                }
            }

        }

        generateProductLink(thisParent);

    }
    


    // Global generate add product link function - first parameter is main parent
    function generateProductLink(parent) {
        if(parent) {

            const parentType = parent.dataset.productType;
            const linkChangeTarget = parent.getElementsByClassName('generate-link-target-js')[0];
            const parentAllColors = parent.getElementsByClassName('generate-link-color-js');
            const parentAllPackages = parent.getElementsByClassName('generate-link-package-js');
            const parentQuantity    = parent.querySelector('.link-quantity-js input');
            const codeInput         = parent.getElementsByClassName('code-name')[0];

            let codeValue = '';
            let colorValue = '';
            let packageValue = '';
            let quantityValue = '';

            let finalLink = '';

            // Check if this product can change colors:
            if(parentAllColors) {
                for(var i = 0; i < parentAllColors.length; i++) {
                    if(parentAllColors[i].classList.contains('active')) {
                        // Set the color same as active one.
                        colorValue = parentAllColors[i].dataset.colorName;
                    }
                }
            }

            // Check if this product can change packages:
            if(parentAllPackages) {
                for(var i = 0; i < parentAllPackages.length; i++) {
                    if(parentAllPackages[i].classList.contains('active')) {
                        // Set the package same as active one.
                        packageValue = parentAllPackages[i].dataset.packageType;
                    }
                }
            }

            // Check if quantity input exists:
            if(parentQuantity) {
                quantityValue = parentQuantity.value;
            }

            if(codeInput) {
                if(codeInput.value) {
                    codeValue = '&coupon=' + codeInput.value;
                }
            }

            // Check what product we have to make correct base link
            if(parentType) {
                if(parentType === 'GJD.13') {
                    if(colorValue == 'granatowy' && packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=22956&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'rozowy' && packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=22964&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'niebieski' && packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=22960&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'rozowy' && packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=22963&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'niebieski' && packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=22959&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'granatowy' && packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=22955&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'granatowy' && packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=22954&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'niebieski' && packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=22958&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'rozowy' && packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=22962&quantity=' + quantityValue + codeValue;
                    }
                } else if(parentType === 'GJD.06') {
                    if(colorValue == 'czarny' && packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=9969&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'rozowy' && packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=9968&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'niebieski' && packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=9967&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'pomaranczowy' && packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=17092&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'oliwkowy' && packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=17089&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'rozowy' && packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=9965&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'niebieski' && packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=9964&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'czarny' && packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=9966&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'pomaranczowy' && packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=17091&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'oliwkowy' && packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=17088&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'czarny' && packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=9496&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'pomaranczowy' && packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=17090&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'oliwkowy' && packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=17086&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'niebieski' && packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=9494&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'rozowy' && packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=9495&quantity=' + quantityValue + codeValue;
                    }
                } else if(parentType === 'BZ.03') {
                    if(colorValue == 'jzielony' && packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=20058&quantity=' + quantityValue + codeValue;
                    } else if(colorValue == 'jrozowy' && packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=20055&quantity=' + quantityValue + codeValue;
                    }
                } else if(parentType === 'BS.03') {
                    if(packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=16511&quantity=' + quantityValue + codeValue;
                    } else if(packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=16513&quantity=' + quantityValue + codeValue;
                    } else if(packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=16514&quantity=' + quantityValue + codeValue;
                    }
                } else if(parentType === 'BS.07') {
                    if(packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=29582&quantity=' + quantityValue + codeValue;
                    } else if(packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=29583&quantity=' + quantityValue + codeValue;
                    } else if(packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=29584&quantity=' + quantityValue + codeValue;
                    }
                } else if(parentType === 'BS.04') {
                    if(packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=15666&quantity=' + quantityValue + codeValue;
                    } else if(packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=15667&quantity=' + quantityValue + codeValue;
                    } else if(packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=15668&quantity=' + quantityValue + codeValue;
                    }
                } else if(parentType === 'BZ.03P') {
                    finalLink = 'https://bezpiecznarodzina.pl/p/lokalizator-gps-dla-psa-bz-02' + packageValue + colorValue + quantityValue + codeValue;
                } else if(parentType === 'BZ.03K') {
                    finalLink = 'https://bezpiecznarodzina.pl/p/lokalizator-gps-dla-kota-bz-02' + packageValue + colorValue + quantityValue + codeValue;
                } else if(parentType === 'BZ.02P') {
                    if(packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=10085&quantity=' + quantityValue + codeValue;
                    } else if(packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=10086&quantity=' + quantityValue + codeValue;
                    } else if(packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=10087&quantity=' + quantityValue + codeValue;
                    }
                } else if(parentType === 'BZ.02K') {
                    if(packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=13219&quantity=' + quantityValue + codeValue;
                    } else if(packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=13220&quantity=' + quantityValue + codeValue;
                    } else if(packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=13221&quantity=' + quantityValue + codeValue;
                    }
                } else if(parentType === 'BA.02') {
                    if(packageValue == 'miesiecznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=10081&quantity=' + quantityValue + codeValue;
                    } else if(packageValue == 'polrocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=10082&quantity=' + quantityValue + codeValue;
                    } else if(packageValue == 'rocznie') {
                        finalLink = 'https://bezpiecznarodzina.pl/koszyk/?add-to-cart=10083&quantity=' + quantityValue + codeValue;
                    }
                }
                
                
            }

            // Finally change link on target buy btn
            if(linkChangeTarget) {
                linkChangeTarget.href = finalLink;
            }

        }
    }


}

export default LandingPages;